import React, {Component} from 'react';
import Icon from "../Icon";
import BurgerMenu from "./BurgerMenu";
import PropTypes from "prop-types";

class BurgerButton extends Component {
  static propTypes = {
    menu: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      opened: false
    }
  }

  onBurgerToggle() {
    this.setState({
      opened: !this.state.opened
    }, () => {
      if (this.state.opened) {
        document.body.classList.add("noscroll");
      } else {
        document.body.classList.remove("noscroll");
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        <BurgerMenu opened={this.state.opened} callback={this.onBurgerToggle.bind(this)} menu={this.props.menu} />
        <button onClick={this.onBurgerToggle.bind(this)}><Icon icon={'bars'} /></button>
      </React.Fragment>
    );
  }
}

export default BurgerButton;